import { render, staticRenderFns } from "./CreateTickets.vue?vue&type=template&id=294c63a2&scoped=true"
import script from "./CreateTickets.vue?vue&type=script&lang=js"
export * from "./CreateTickets.vue?vue&type=script&lang=js"
import style0 from "./CreateTickets.vue?vue&type=style&index=0&id=294c63a2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "294c63a2",
  null
  
)

export default component.exports